import { gql } from "@apollo/client";
import { REPORT_TEMPLATE_FRAGMENT } from "./getReportsTemplateCall";
import { ReportTemplate } from "../../../../Definitions";

export const UPDATE_REPORT_TEMPLATE = gql`
  mutation UpdateTemplate($domain: String!, $templateId: Int!, $name: String!, $dataLevel: Int!, $filterParameter: [[FilterInput!]!]!, $shouldArchive: Boolean!) {
    report {
      updateTemplate(domain: $domain, report_template_id: $templateId, name: $name, data_level: $dataLevel, filter: $filterParameter, should_archive: $shouldArchive) {
        ...ReportTemplateFields
      }
    }
  }
  ${REPORT_TEMPLATE_FRAGMENT}
`


export interface UpdateReportTemplateResponse {
  report: {
    updateTemplate: ReportTemplate[] 
  }
}